import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function CheckCircleOutline(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm-1 14l-4-4 1.41-1.41L11 13.17l5.59-5.59L18 9l-7 7z" />
    </SvgIcon>
  )
}
